import {Component, OnInit} from '@angular/core';
import {EditionService, EditiontQuery} from '../../services/edition.service';
import {CardConditionService} from '../../services/card-condition.service';
import {ToastrService} from 'ngx-toastr';
import {CardQuery, CardService} from '../../services/card.service';
import {Observable} from 'rxjs/Observable';
import {Card, Edition, ProductDetail, StockRule, StockRulePreference} from '../../core/entities/entities';
import {WarehouseService} from '../../services/warehouse.service';
import {LanguageService} from '../../services/language.service';
import * as Rx from 'rxjs/Rx';
import {ActivatedRoute, Router} from '@angular/router';
import {ComponentBase} from '../../core/entities/component-base';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {StockRuleService, MultipleStockRuleDTO} from '../../services/stock-rule.service';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-stock-rule-add',
  templateUrl: './stock-rule-add.component.html',
  styleUrls: ['./stock-rule-add.component.css']
})
export class StockRuleAddComponent extends ComponentBase implements OnInit {


  card_search: CardQuery = {autocomplete_edition: '', autocomplete_card_name: '', autocomplete_language: this.defaultLanguageId};
  cards: Observable<Card[]>;
  card: Card;
  private _cardMap: { [key: string]: ProductDetail } = {};
  selectedCards: ProductDetail[] = [];


  enableRule = {
    cardId: {
      not: ['editionId', 'hot', 'rarityId']
    },
    editionId: {
      not: ['cardId']
    },

    productName: {
      not: ['cardId'],
      disabled: ['cardId']
    },

    languageSearchId: {
      need: ['productName'],
      not: ['cardId'],
      disabled: ['cardId']
    },

    hot: {
      not: ['cardId']
    },
    rarityId: {
      not: ['cardId']
    },

  };

  isDisabled(field: string) {
    const me = this;
    const rule = this.enableRule[field];

    let disabilitato = false;

    Object.keys(me.item).forEach(key => {
      if (me.item[key] == 'null') {
        me.item[key] = null;
      }
    });

    if (rule) {
      if (rule.need) {
        // se trovo null obbligatorie
        disabilitato = rule.need.some(key => {
            return (Array.isArray(me.item[key]) && me.item[key] && me.item[key].length == 0) || (!Array.isArray(me.item[key]) && isNullOrUndefined(me.item[key]));
          }
        );
      }

      if (!disabilitato && rule.not) {
        // se trovo !null non richieste
        disabilitato = rule.not.some(key => {
            return (Array.isArray(me.item[key]) && me.item[key] && me.item[key].length > 0) || (!Array.isArray(me.item[key]) && !isNullOrUndefined(me.item[key]));
          }
        );
      }

      if (!disabilitato && rule.disabled) {
        // se trovo il campo abilitato
        disabilitato = rule.disabled.some(key => {
            return !me.isDisabled(key);
          }
        );
      }
    }

    if (disabilitato) {
      me.item[field] = null;
    } else if ((Array.isArray(me.item[field]) && me.item[field] && me.item[field].length == 0) || (!Array.isArray(me.item[field]) && isNullOrUndefined(me.item[field]))) {
      me.item[field] = me.item[field];
    }

    return disabilitato;

  }


  selectCard(event: TypeaheadMatch) {
    if (event && event.item) {

      //this.card = event.item;
      this.selectedCards.push(event.item);
      this.item.cardId = this.selectedCards.map(card => card.id);
      this.card_search.autocomplete_card_name = null; // this.card.name;
      this.card_search.autocomplete_edition = null; // this.card.edition;
      //this.item.cardId = event.item.id; //this.card.id;
      this.eraseEdition();

    }
  }

  removeCard(id: any) {
    this.selectedCards = this.selectedCards.filter(ed => ed.id != id);
    this.item.cardId = this.item.cardId.filter(ed => ed != id);
  }


  eraseCard() {
    this.card_search.autocomplete_edition = '';
    this.item.cardId = null;
    this.card = null;
    //
    this.item['cardData'] = null;
    // this.selectedCards = []
  }

  selectEdition(event: TypeaheadMatch) {
    if (event && event.item) {
      this.edition_search.edition = null;
      this.edition = event.item;
      this.selectedEditions.push(event.item);
      this.eraseCard();
      this.edition = null;
    }
  }

  removeEdition(id: any) {
    this.selectedEditions = this.selectedEditions.filter(ed => ed.id != id);
    this.item.editionId = this.item.editionId.filter(ed => ed != id);
  }

  eraseEdition() {
    this.edition_search.edition = null;
    this.item.editionId = null;
    this.edition = null;
    // this.selectedEditions = [];
  }

  private _editionMap: { [key: string]: Edition } = {};
  selectedEditions: Edition[] = [];
  edition_search: EditiontQuery = {edition_name: '', type: 0, wh_id: null};
  editions: Rx.Observable<Edition[]>;
  edition: Edition;


  get warehouses() {
    return Observable.create((observer: any) => {
      this._warehouseService.dataChange.subscribe(ret => observer.next(ret.filter(w => !w.refill)));
    });
  }

  get languages() {
    return this._languageService.dataChange;
  }

  get conditions() {
    return this._cardConditionService.dataChange;
  }

  item = new MultipleStockRuleDTO();

  constructor(protected _stockRuleService: StockRuleService,
              protected _route: ActivatedRoute,
              protected _languageService: LanguageService,
              protected _warehouseService: WarehouseService,
              protected _cardConditionService: CardConditionService,
              protected _cardService: CardService,
              protected _editionServ: EditionService,
              protected _router: Router,
              protected _toastrService: ToastrService) {
    super();
  }

  ngOnInit() {
    const me = this;
    this.item.preferences = [];
    this.cards = Rx.Observable.create((observer: any) => {
      observer.next(this.card_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
        return this._cardService.search({...term, categoryId: this.categoryId, brandId: this.brandId});
      });

    this.editions = Rx.Observable.create((observer: any) => {
      observer.next(this.edition_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
        return this._editionServ.search({...term, brandId: this.brandId });
      });

    console.log(this.item);

  }

  clearFilters() {
    this.eraseCard();
    this.eraseEdition();
    this.edition_search.edition = null;
  }


  addPreference() {
    this.item.preferences.push(new StockRulePreference());
  }

  removePreference(prefe: StockRulePreference, index: number) {
    this.item.preferences.splice(index, 1);
  }


  add() {
    this.item.editionId = this.selectedEditions.map(edition => edition.id);
    this.item.cardId = this.selectedCards.map(card => card.id);

    this.item.categoryId = this.categoryId;
    this.item.brandId = this.brandId;
    this.clear(this.item);
    if(this.item.preferences && this.item.preferences.length > 0) {
      this.item.preferences.forEach( p => this.clear(p));
    }
    this.spinnerService.show();
    this._stockRuleService.insert(this.item).subscribe(ret => {
      this._toastrService.success('Eseguito Correttamente!');
      this._router.navigateByUrl('/home/stock_rules');
    });
  }






}



// WEBPACK FOOTER //
// ./src/app/conf/stock-rule-add/stock-rule-add.component.ts